import { render } from "./tw-tabview.vue?vue&type=template&id=356f0892"
import script from "./tw-tabview.vue?vue&type=script&lang=js"
export * from "./tw-tabview.vue?vue&type=script&lang=js"
script.render = render

export default script